const TOKEN_IDENTIFIER = 'iframe-user-token';

export function getToken() {
  return localStorage.getItem(TOKEN_IDENTIFIER);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_IDENTIFIER, token);
}
